import gql from 'graphql-tag';

const GET_HOMEPAGE_WIDGETS_LIST = gql`
  query getAllHomePageWidgets($listInfo: ListInfoInput!) {
    getAllHomePageWidgets(listInfo: $listInfo) {
      homePageWidgets {
        widgetId
        widgetType
        listView {
          id
          name
          viewCondition
          customView
          shared
          systemViewProperty
          module
        }
      }
      listInfo {
        hasMore
      }
    }
  }
`;

const GET_MY_MENTIONS = gql`
  query($listInfo: ListInfoInput!) {
    getMyMentions(listInfo: $listInfo) {
      mentions {
        mentionId
        type #MentionEntityType
        time
        note {
          noteId
          ticket {
            ticketId
            displayId
            subject
          }
          workItem {
            workId
            module
            subject
            displayId
          }
          addedBy {
            userId
            name
            firstName
            lastName
          }
          addedOn
          content
        }
        projectConversation {
          conversationId
          content
          addedBy {
            userId
            name
            firstName
            lastName
          }
          addedOn
          attachments {
            fileName
            originalFileName
            fileSize
          }
          project {
            projectId
            displayId
            title
            status
          }
        }
      }
      listInfo {
        hasMore
        page
        pageSize
        totalCount
      }
    }
  }
`;

// enum MentionEntityType {
//   NOTE
//   PROJECT_CONVERSATION
// }

export { GET_HOMEPAGE_WIDGETS_LIST, GET_MY_MENTIONS };
